// extracted by css-extract-rspack-plugin
export default {"search_form_input":"byqss","searchFormInput":"byqss","icon":"d_udQ","input":"JcvZ_","label":"HCJKH","short":"lecjY","button_override":"HoKLA","buttonOverride":"HoKLA","#":"u2_d3"};